export const state = {
    user: {
        id: "",
        title: {
            th: "",
            en: ""
        },
        name: {
            th: "",
            en: ""
        },
        last_name: {
            th: "",
            en: ""
        },
        email: "",
        birthDate: "2021-05-16T05:14:13.226Z",
        age: 0,
        gender: "",
        photo: "",
        phones: [
            {
                type: "",
                value: "",
                is_default: true
            }
        ],
        central_employee_info: {
            crc_id: "",
            ofm_id: "",
            psgv2_id: "",
            department_name: ""
        },
        person_locale: "",
        create_info: {
            crc_id: "",
            ofm_id: "",
            psgv2_id: "",
            department_name: ""
        }
    },
};

export const mutations = {
    ADD_USER: (state, data) => {
        state.user = data;
    },
    CLEAR_USER: (state) => {
        state.user = {
            id: "",
            title: {
                th: "",
                en: ""
            },
            name: {
                th: "",
                en: ""
            },
            last_name: {
                th: "",
                en: ""
            },
            email: "",
            birthDate: "2021-05-16T05:14:13.226Z",
            age: 0,
            gender: "",
            photo: "",
            phones: [
                {
                    type: "",
                    value: "",
                    is_default: true
                }
            ],
            central_employee_info: {
                crc_id: "",
                ofm_id: "",
                psgv2_id: "",
                department_name: ""
            },
            person_locale: "",
            create_info: {
                crc_id: "",
                ofm_id: "",
                psgv2_id: "",
                department_name: ""
            }
        }
    },
};

export const getters = {
    GET_USER: state => state.user,
};

export const actions = {
    ADD_USER: ({ commit }, data) => {
        commit('ADD_USER', data);
    },
    CLEAR_USER: ({ commit }) => {
        commit('CLEAR_USER');
    },
};
